
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	standalone: true,
	selector: 'flopfooter',
	imports: [RouterModule],
	templateUrl: './flopfooter.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './flopfooter.component.scss'
})
export class FlopFooterComponent {

	year: number = new Date().getFullYear();

	constructor(
		private router: RouterModule
	) {

	}
}
